import React, { memo } from "react";
import PropTypes from "prop-types";

import Table from "../../common/Table";
import Row from "../../common/Row";
import { Popup } from 'semantic-ui-react';
import ConfirmModal from "../../common/ConfirmModal";

import idIcon from "../../../images/idIcon.jpg";

const OverzichtOrganisatiesForm = (props) => {
	const {
		sportclubModels,
		onSortTable,
		filter,
		totalPages,
		totalItems,
		onPageChange,
		onEditSportclub,
		onCopyPoId,
		onOpenDeleteModal,
		onOpenCancelModal,
		onCloseDeleteModal,
		deleteModalIsOpen,
		modalSportclub,
		onDeleteSportclub,
		onLinkSportclub,
		onChangePageSize,
		onCancelLink,
		foundPoIdBelongsToFederatie
	} = props;

	const tdStyle = { padding: "5px" };

	function handleOnEditSportclub(id, isNew, isReadonly) {
		return function () {
			onEditSportclub(id, isNew, isReadonly);
		};
	}

	function handleOnCopyPoId(poId) {
		return function (event) {
			onCopyPoId(poId, event);
		};
	}

	function handleDeleteSportclub(id) {
		return function (event) {
			onDeleteSportclub(id, event);
		};
	}
	function handleLinkSportclub(id) {
		return function (event) {
			onLinkSportclub(id, event);
		};
	}
	function handleOnOpenCancelModal(transactie) {
		return function (event) {
			onOpenCancelModal(transactie, event);
		};
	}

	function handleOnOpenDeleteModal(sportclub) {
		return function (event) {
			onOpenDeleteModal(sportclub, event);
		};
	}

	function returnTdContent(text) {
		return text.length > 40 ? <Popup wide="very" position="top left" trigger={<p>{text.substring(0, 40) + "..."}</p>} content={text} /> : text;
	}


	function getActions(club) {
		// Tabel aangesloten sportclubs
		if(club.belongsToFederatie){
			return (
				<td style={{ paddingBottom: '2px', paddingTop: '2px' }}>
					<Popup wide="very" trigger={<img style={{ cursor: 'pointer', "height": "1rem", "margin": "0 5px" }} src={idIcon} onClick={handleOnCopyPoId(club.id)} />} content={"Kopieer PO-id : " + club.id} position="left center" />

					{club.transactionType === "Unlink" ? null :
						club.status === "In Behandeling" ?
							<Popup wide="very" trigger={<i className="fa fa-eye" style={{ cursor: 'pointer', "margin": "0 5px" }} onClick={handleOnEditSportclub(club.id, false, true)} />} content={"Toon detail sportclub. Je kan deze sportclub niet wijzigen omdat Sport Vlaanderen momenteel een wijzigingsaanvraag van deze sportclub verwerkt."} position="left center" /> :
							<Popup wide="very" trigger={<i className="fa fa-pencil" style={{ cursor: 'pointer', "margin": "0 5px" }} onClick={handleOnEditSportclub(club.id, false, false)} />} content={"Wijzig detail sportclub"} position="left center" />}
					{(club.status === "In Behandeling" || club.transactionType === "Edit") ?
						null
						: club.transactionType === "Unlink" ?
							<Popup wide="very" trigger={<i className="fa fa-link" style={{ cursor: 'pointer', "margin": "0 5px" }} onClick={handleOnOpenCancelModal({ transactieId: club.transactieId, aanvraagType: club.transactionType })} />} content={"Voeg lidmaatschap toe"} position="left center" />
							: <Popup wide="very" trigger={<i className="fa fa-unlink" style={{ cursor: 'pointer', "margin": "0 5px" }} onClick={handleOnOpenDeleteModal(club)} />} content={"Verwijder lidmaatschap"} position="left center" />}
				</td>
			);
		} else{ //Tabel niet aangesloten sportclub
			return (
				<td style={{ paddingBottom: '2px', paddingTop: '2px' }}>
					<Popup wide="very" trigger={<img style={{ cursor: 'pointer', "height": "1rem", "margin": "0 5px" }} src={idIcon} onClick={handleOnCopyPoId(club.id)} />} content={"Kopieer PO-id : " + club.id} position="left center" />
					{club.status === "In Behandeling" ?
							<Popup wide="very" trigger={<i className="fa fa-eye" style={{ cursor: 'pointer', "margin": "0 5px" }} onClick={handleOnEditSportclub(club.id, false, true)} />} content={"Toon detail sportclub. Je kan deze sportclub niet wijzigen omdat Sport Vlaanderen momenteel een wijzigingsaanvraag van deze sportclub verwerkt."} position="left center" />
							: club.transactionType === "Link" || club.transactionType == "Edit" ?
							<Popup wide="very" trigger={<i className="fa fa-pencil" style={{ cursor: 'pointer', "margin": "0 5px" }} onClick={handleOnEditSportclub(club.id, false, false)} />} content={"Wijzig detail sportclub"} position="left center" />
							: null}
					{(club.status === "In Behandeling") ?
						null
						: club.transactionType === "Link" || club.transactionType == "Edit" ?
						<Popup wide="very" trigger={<i className="fa fa-unlink" style={{ cursor: 'pointer', "margin": "0 5px" }} onClick={handleOnOpenCancelModal({ transactieId: club.transactieId, aanvraagType: club.transactionType })} />} content={"Verwijder lidmaatschap"} position="left center" />
						: <Popup wide="very" trigger={<i className="fa fa-link" style={{ cursor: 'pointer', "margin": "0 5px" }} onClick={handleOnOpenDeleteModal(club)} />} content={"Voeg lidmaatschap toe"} position="left center" />}

						</td>
			);
		}


	}

	const clubRows = sportclubModels.map((club, i) => {
		const clubNaam = club.name + (club.afkorting ? " (" + club.afkorting + ")" : "");
		const clubPlaats = club.gemeente;
		const clubIdentificatiecode = club.identificatieCode ? club.identificatieCode : "";
		return (<tr className={club.transactionType === "Unlink" ? 'crossedText' : null} style={{ borderStyle: 'solid', borderWidth: "1px", borderColor: '#eeefef', height: '100%' }} key={i} height="80" >
			<td style={tdStyle}>{returnTdContent(clubNaam)}</td>
			<td style={tdStyle}>{returnTdContent(clubPlaats)}</td>
			<td style={tdStyle}>{returnTdContent(clubIdentificatiecode)}</td>
			<td style={tdStyle}>{returnTdContent(club.actief ? 'Actief' : 'Inactief')}</td>
			{getActions(club)}
		</tr >);
	});

	const tableTitle = foundPoIdBelongsToFederatie ? totalItems + " aangesloten sportclubs" : totalItems + " niet aangesloten sportclub" ;

	return (
		<div className="o-col-12">
			{deleteModalIsOpen && <ConfirmModal
				isOpen={deleteModalIsOpen}
				title={
					modalSportclub.transactionType === "Unlink" ? "Voeg lidmaatschap toe" :
						modalSportclub.transactionType === "Link" ? "Verwijder lidmaatschap" :
						modalSportclub.belongsToFederatie ? "Verwijder lidmaatschap" :
						"Voeg lidmaatschap toe"}
				mainText={
					modalSportclub.transactionType === "Unlink" ? "Hiermee meld je aan Sport Vlaanderen dat " + modalSportclub.name + " aangesloten is bij jouw sportfederatie." :
						modalSportclub.transactionType === "Link" ? "Hiermee meld je aan Sport Vlaanderen dat " + modalSportclub.name + " niet langer aangesloten is bij jouw sportfederatie." :
						modalSportclub.belongsToFederatie ? "Hiermee meld je aan Sport Vlaanderen dat " + modalSportclub.name + " niet langer aangesloten is bij jouw sportfederatie." :
						"Hiermee meld je aan Sport Vlaanderen dat " + modalSportclub.name + " aangesloten is bij jouw sportfederatie."}
				confirmAction={
					modalSportclub.transactionType === "Unlink" ? onCancelLink(modalSportclub.transactieId) :
						modalSportclub.transactionType === "Link" ? onCancelLink(modalSportclub.transactieId) :
						modalSportclub.belongsToFederatie ? handleDeleteSportclub(modalSportclub.id) :
						handleLinkSportclub(modalSportclub.id)
							}
				cancelAction={onCloseDeleteModal}
				confirmText="Ga verder"
				cancelText="Annuleer"
			/>}

			<div id="copyToClipboardContainer" />
			<Row>
				{
					totalItems > 0 ?
						<Table
							title={tableTitle}
							headers={["Naam (Afkorting)", "Gemeente", "Code", "Actief", ""]}
							headerSizes={[36, 30, 10, 10]}
							onClickHeader={onSortTable}
							sortableColumns={[0, 1]}
							activePage={filter.pageNo}
							pageSize={filter.pageSize}
							totalPages={totalPages}
							onPageChange={onPageChange}
							changePageSize={onChangePageSize}
							totalItems={totalItems}
						>
							{clubRows}
						</Table>
						:
						<div>
								<p style={{ margin: "15px 0" }}>Geen sportclubs gevonden die voldoen aan de opgegeven zoekcriteria.</p>
						</div>
				}
			</Row>
		</div>
	);
};

OverzichtOrganisatiesForm.propTypes = {
	sportclubModels: PropTypes.array,
	onSortTable: PropTypes.func,
	onPageChange: PropTypes.func,
	onEditSportclub: PropTypes.func,
	onDeleteSportclub: PropTypes.func,
	onLinkSportclub: PropTypes.func,
	onCopyPoId: PropTypes.func,
	onOpenDeleteModal: PropTypes.func,
	onCloseDeleteModal: PropTypes.func,
	onCancelLink: PropTypes.func,
	onOpenCancelModal: PropTypes.func,
	deleteModalIsOpen: PropTypes.bool,
	modalSportclub: PropTypes.object,
	filter: PropTypes.object,
	totalItems: PropTypes.number,
	totalPages: PropTypes.number,
	onChangePageSize: PropTypes.func,
	filterHasValidPoId: PropTypes.bool,
	foundPoIdBelongsToFederatie: PropTypes.bool,
};

export default memo(OverzichtOrganisatiesForm);
